import styled from "@emotion/native";
import * as drawer from "myplan/utils/drawer";
import { Platform } from "react-native";

export const Container = styled.SafeAreaView(
    {
        flex: 1,
        zIndex: 1,
    },
    ({ theme }: any) => {
        return {
            backgroundColor: theme.color.background,
        };
    },
);
export const Header = styled.View({
    justifyContent: "center",
    alignItems: "center",
});

export const SectionImage = styled.Image({
    height: 215,
    width: "65%",
    marginLeft: 25,
    marginTop: 20,
});
export const LogoutButton = styled.TouchableOpacity({
    height: 75,
    width: 75,
    marginHorizontal: 10,
    position: "absolute",
    zIndex: 10000,
});

export const Scroll = styled.ScrollView({
    paddingTop: 60,
    overflow: Platform.OS === ("android" || "web") ? "scroll" : "visible",
    paddingHorizontal: 20,
    marginBottom: drawer.BUTTON_HEIGHT + drawer.MARGIN_BOTTOM,
});
